// Guest model

const GUEST = [
  { id: "adult", name: "adult" },
  { id: "child", name: "child" },
];

const SEX = [
  { id: "female", name: "female" },
  { id: "male", name: "male" },
];

const TYPES = [
  { id: "13", name: "Cédula Ciudadania" },
  { id: "41", name: "Pasaporte" },
  { id: "12", name: "Tarjeta Identidad" },
  { id: "11", name: "Registro Civil" },
  { id: "21", name: "Tarjeta Extranjeria" },
  { id: "22", name: "Cedula Extranjeria" },
  { id: "42", name: "Tipo Documento Extranjero" },
  { id: "47", name: "PEP" },
  { id: "91", name: "NUIP" },
];

function layout() {
  const ctxView = {
    model: "hotel.folio.guest",
    form_action: [],
    table_action: ["edit"],
    orderBy: [["name", "ASC"]],
    selectable: null, // Options for table rows: null, multi, one
    activeSearch: true,
    defaultView: "list",
    fields: {
      name: { type: "char", readOnly: true, searchable: true },
      type_guest: {
        type: "selection",
        options: GUEST,
        readOnly: true,
      },
      type_document: {
        type: "selection",
        options: TYPES,
        readOnly: true,
      },
      sex: {
        type: "selection",
        options: SEX,
        readOnly: true,
        default: { id: "male", name: "male" },
      },
      id_number: { type: "char", readOnly: true, searchable: true },
      mobile: {
        type: "char",
        readOnly: true,
      },
      email: {
        type: "char",
        readOnly: true,
      },
      address: {
        type: "char",
        readOnly: true,
      },
      birthday: { type: "date", required: true, readOnly: true },
      profession: { type: "char", readOnly: true },
      notes: { type: "text" },
      foreign_city: { type: "char", readOnly: true },
      // arrival_date: { type: "date", readOnly: true },
      // departure_date: { type: "date", readOnly: true },
      main_guest: {
        type: "boolean",
        readOnly: true,
      },
      nationality: {
        type: "many2one",
        model: "country.country",
        readOnly: true,
      },
      folio: {
        type: "many2one",
        model: "hotel.folio",
        readOnly: true,
      },
      origin_country: {
        type: "many2one",
        model: "country.country",
        readOnly: true,
      },
      target_country: {
        type: "many2one",
        model: "country.country",
        readOnly: true,
      },
    },
    list: [
      { name: "name", width: "25%" },
      { name: "id_number", width: "10%" },
      { name: "type_document", width: "10%" },
      { name: "mobile", width: "10%" },
      { name: "birthday", width: "5%" },
      { name: "nationality", width: "5%" },
      { name: "sex", width: "5%" },
    ],
    form: [
      { name: "name" },
      {
        name: "info1",
        type: "grid",
        elements: [{ name: "id_number" }, { name: "main_guest" }],
        colSpan: "col-span-1",
      },
      { name: "mobile" },
      {
        name: "info2",
        type: "grid",
        elements: [{ name: "type_guest" }, { name: "type_document" }],
        colSpan: "col-span-1",
      },
      { name: "email" },
      {
        name: "info3",
        type: "grid",
        elements: [{ name: "birthday" }, { name: "sex" }],
        colSpan: "col-span-1",
      },
      { name: "nationality" },
      {
        name: "info_country",
        type: "grid",
        elements: [{ name: "origin_country" }, { name: "target_country" }],
        colSpan: "col-span-1",
      },
      { name: "address" },
      { name: "foreign_city" },
      { name: "folio" },
      { name: "notes" },
    ],
    card: [
      { name: "name" },
      { name: "id_number" },
      { name: "type_guest" },
      { name: "main_guest" },
      { name: "sex" },
      { name: "birthday" },
      { name: "nationality" },
      { name: "mobile" },
      { name: "email" },
      { name: "notes" },
    ],
  };

  return ctxView;
}

export { layout };
